define(["require", "exports", "./schema/model-schema.class"], function (require, exports, model_schema_class_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ModelsManager = /** @class */ (function () {
        function ModelsManager(_usePrefix) {
            if (_usePrefix === void 0) { _usePrefix = true; }
            this._usePrefix = _usePrefix;
            this._schemas = {};
        }
        ModelsManager.prototype.addSchema = function (type, attributes) {
            if (this._schemas[type]) {
                console.log("Models manager: attempt to override a schema width this type id: " + type + ". Addition ignored.");
                return;
            }
            this._schemas[type] = new model_schema_class_1.ModelSchema(attributes);
        };
        ModelsManager.prototype.extendsSchema = function (type, extension) {
            if (!this._schemas[type]) {
                console.log("Models manager: attempt to extends a schema which does not exists : " + type + ". Extension ignored.");
                return;
            }
            var schema = this._schemas[type];
            var version = schema.edgeVersion + 1;
            schema.addVersion(version, extension);
            return version;
        };
        ModelsManager.prototype._getSchema = function (type) {
            if (!this._schemas[type]) {
                console.log("Models manager: trying to query a schema with unknown type id: " + type + ".");
                return null;
            }
            return this._schemas[type];
        };
        ModelsManager.prototype.getDefaults = function (type, defaults, version) {
            if (defaults === void 0) { defaults = null; }
            if (version === void 0) { version = null; }
            var schema = this._getSchema(type);
            if (!schema) {
                console.log("Get defaults failed: " + type);
                return null;
            }
            return schema.generateModel(version, defaults);
        };
        ModelsManager.prototype.validate = function (type, object, version) {
            if (version === void 0) { version = null; }
            var schema = this._getSchema(type);
            if (!schema) {
                return false;
            }
            return schema.validateModel(object, version);
        };
        ModelsManager.prototype.blindValidate = function (type, object) {
            var schema = this._getSchema(type);
            if (!schema) {
                return false;
            }
            return schema.blindValidate(object);
        };
        ModelsManager.prototype.update = function (type, object, version) {
            if (version === void 0) { version = null; }
            var schema = this._getSchema(type);
            if (!schema) {
                return {};
            }
            return schema.filterModel(object, version);
        };
        ModelsManager.prototype.toStoreData = function (type, object, version) {
            if (version === void 0) { version = null; }
            var schema = this._getSchema(type);
            if (!schema) {
                return null;
            }
            return schema.getVersionedAttributes(object, version, this._usePrefix);
        };
        ModelsManager.prototype.toClientData = function (type, object, version) {
            if (version === void 0) { version = null; }
            var schema = this._getSchema(type);
            if (!schema) {
                return null;
            }
            return schema.getFromVersionedAttributes(object, version, this._usePrefix);
        };
        ModelsManager.mergeVersions = function (storeVersion, clientVersion) {
            var attributes = {};
            for (var key in storeVersion) {
                if (storeVersion.hasOwnProperty(key)) {
                    attributes[key] = storeVersion[key];
                }
            }
            for (var key in clientVersion) {
                if (clientVersion.hasOwnProperty(key)) {
                    attributes[key] = clientVersion[key];
                }
            }
            return attributes;
        };
        return ModelsManager;
    }());
    exports.ModelsManager = ModelsManager;
});
